import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps"; // Import package

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCkstdpSOX29O2laJWSYWLaYbeJs7HFTeM",
    libraries: "places",
  },
}); 
